export default {
  rootDeviceGroup: '/p/:persona/deviceGroup',
  rootDeviceGroupItem: '/p/:persona/deviceGroup/:deviceGroupId',
  rootDeviceGroupItemInfo: '/p/:persona/deviceGroup/:deviceGroupId/info',
  rootDevice: '/p/:persona/device',
  rootDeviceItem: '/p/:persona/device/:deviceId',
  rootDeviceItemInfo: '/p/:persona/device/:deviceId/info',
  rootDeviceType: '/p/:persona/deviceType',
  rootDeviceTypeItem: '/p/:persona/deviceType/:deviceTypeId',
  rootDeviceTypeItemInfo: '/p/:persona/deviceType/:deviceTypeId/info',
  rootFirmwareRelease: '/p/:persona/firmwareRelease',
  rootFirmwareReleaseItem: '/p/:persona/firmwareRelease/:firmwareReleaseId',
  rootFirmwareReleaseItemInfo: '/p/:persona/firmwareRelease/:firmwareReleaseId/info',
  rootFirmwareApplication: '/p/:persona/firmwareApplication',
  rootFirmwareApplicationItem: '/p/:persona/firmwareApplication/:firmwareApplicationId',
  rootFirmwareApplicationItemInfo: '/p/:persona/firmwareApplication/:firmwareApplicationId/info',
  rootFirmwareComponent: '/p/:persona/firmwareComponent',
  rootFirmwareComponentItem: '/p/:persona/firmwareComponent/:firmwareComponentId',
  rootFirmwareComponentItemInfo: '/p/:persona/firmwareComponent/:firmwareComponentId/info'
};